import React from 'react';
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';

function Strip() {
  return (
    <AppBar position="static" style={{ backgroundColor: '#0e7693', color: 'white', height: '36px', marginTop: '-80px' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, height: '36px' }}>
          <Typography variant="h6" component="div" style={{ fontSize: '14px', whiteSpace: "nowrap" }}>
            उत्तर प्रदेश सरकार
          </Typography>
          <Typography variant="h6" component="div" style={{ fontSize: '14px' }}>
            |
          </Typography>
          <Typography variant="h6" component="div" style={{ fontSize: '12px', whiteSpace: "nowrap" }}>
            Government of Uttar Pradesh
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, height: '36px' }}>
          <IconButton size="small" aria-label="Facebook" onClick={() => window.open('https://www.facebook.com/HP-Department-of-Urban-Development-Shimla-1494597044125270/', "_blank")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="white"
              viewBox="0 0 16 16"
            >
              <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
            </svg>
          </IconButton>
          <IconButton size="small" aria-label="Twitter now X" onClick={() => window.open('https://www.twitter.com/UDHIMACHAL', "_blank")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="white"
              viewBox="0 0 16 16"
            >
            <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15"/>
          </svg>
          </IconButton>
          {/* <img src='https://www.hsvphry.org.in/assets/img/font-small.png' alt='decrease' style={{ width: '22px', height: '22px' }} />
          <img src='https://www.hsvphry.org.in/assets/img/font-small.png' alt='normal' style={{ width: '22px', height: '22px' }} />
          <img src='https://www.hsvphry.org.in/assets/img/font-normal-size.png' alt='increase' style={{ width: '22px', height: '22px' }} />
          <img src='https://www.hsvphry.org.in/assets/img/font-white.png' alt='dark' style={{ width: '22px', height: '22px' }} />
          <img src='https://www.hsvphry.org.in/assets/img/font-black.png' alt='default' style={{ width: '22px', height: '22px' }} />
          <Typography variant="h6" component="div">
            हिंदी
          </Typography>
          <input type='text' placeholder='Search here...' /> */}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Strip;
